"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function errorsFromPath(path, keys, errors) {
    var compErrors = {};
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        var newPath = "" + path + key;
        var slice = errors[newPath];
        if (slice) {
            compErrors[key] = slice;
        }
    }
    return compErrors;
}
exports.errorsFromPath = errorsFromPath;
//# sourceMappingURL=errorsFromPath.js.map